import { render, staticRenderFns } from "./module-title.vue?vue&type=template&id=959b516a&scoped=true&"
import script from "./module-title.vue?vue&type=script&lang=ts&"
export * from "./module-title.vue?vue&type=script&lang=ts&"
import style0 from "./module-title.vue?vue&type=style&index=0&id=959b516a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959b516a",
  null
  
)

export default component.exports